

















































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import CustomDataTable from '@/views/report/Table.vue';
import Notes from '@/components/notes/notes.vue';
import ReportBase from './reports/report-base';
import ReportAPI from '@/services/rest/bemob/report';
import formatters from './formatters';
import ReportSorting from './reports/pickers/report-sorting.vue'; // do we need this?
import LoadingBlock from './reports/views/loading-block.vue';
import ErrorBlock from './reports/views/error-block.vue';
import NoReportData from './reports/views/no-data-block.vue';

import ReportEventsMixin from '@/views/reports/mixins/report-events.vue';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import reportUtils from './reports/report-utils';
import _, { isEqual, cloneDeep, uniq, debounce } from 'lodash';
import { AppErrorEnum, DrillFilterOptionsEnum } from '@/services/models/Enums';
import BaseMetricsMixin from '@/views/reports/pickers/base/base-metrics-mixin';

import { normalizeId }  from '@/components/datatable/table-selection';

import api from '@/services/utils/base';
import config from '@/config';
import qs from 'qs';
import moment from 'moment';

Component.registerHooks([
  'beforeRouteUpdate',
  'beforeRouteLeave'
]);

const reportApi = new ReportAPI();

//#GDB -- report condition block; block that depends of report grouping

@Component({
  components: {
    LoadingBlock,
    NoReportData,
    ErrorBlock,
    Notes,
    CustomDataTable,
  },
})
class Report extends mixins<ReportBase, ReportEventsMixin, ReportMetricsMixin, BaseMetricsMixin, UrlMixin>(ReportBase, ReportEventsMixin, ReportMetricsMixin, BaseMetricsMixin, UrlMixin) {
  @Prop() 
  parentRow!: any;

  @Prop()
  previousFilter!: Bemob.ReportQueryDrill[];

  @Prop({default: undefined})
  treeView!: any[];

  @Prop({default: 0})
  treeLevel!: number;

  @Prop()
  type!: string;

  mounted() {
    this.bus.on('report-tab-added', this.onBusReportTabAdded);
    this.bus.on('report-tab-updated', this.onBusReportTabUpdated);
    this.bus.on('update-report-row', this.onBusUpdateReportRow);
    this.bus.on('reset-report-tree', this.onBusResetReportTree);
  }

  beforeDestroy() {
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
    this.bus.off('report-tab-updated', this.onBusReportTabUpdated);
    this.bus.off('update-report-row', this.onBusUpdateReportRow);
    this.bus.off('apply-filters', this.onBusUpdateReportRow);
    this.bus.off('reload-report', this.onBusReloadReport);
    this.bus.off('refresh-report', this.onBusRefreshReport);
    this.bus.off('reset-report-tree', this.onBusResetReportTree);
  }

  onBusReportTabAdded() {
    this.getReport()
  }

  onBusReportTabUpdated() {
    this.getReport()
  }

  onBusResetReportTree() {
    this.tree = {}
  }

  onBusUpdateReportRow({id,data}:{id,data:{ newData, column}[]}){
    this.pRows = this.pRows.map(row=>{
      if(row.DT_RowId===id){
        data.forEach(({newData,column})=>{
          row[column]=newData
        })
      }
      return row
    })
  }

  @Prop()
  columnsWidth!: any;

  get target(): any { return this };

  pRows: any[] = [];

  get treeViewClass() {
    return this.$store.getters.tableQueryForCurrentTab?.treeLevels?.length
  }

  get treeViewValue() {
    return this.isTreeView && (this.treeView || this.$store.getters.tableQueryForCurrentTab.treeLevels?.filter((item)=>!!item))
  }

  get mainColumnLabels() {
    return {
      unknown:  this.t('Unknown'),
      directLinking: this.t('Direct linking'),
      empty: this.t('Empty'),
      none: this.t('None'),
      wiFi: this.t('Wi-Fi'),
      directUrl: this.t('Direct URL')
    };
  }

  get mainColumnStub() {
    switch(this.type) {
      case 'landings':
        return this.mainColumnLabels.directLinking;

      case 'traffic_sources': 
      case 'flows':
      case 'affiliate_networks':
        return this.mainColumnLabels.none;

      case 'offers':
        return this.mainColumnLabels.directUrl;

      case 'mobile_carriers':
        return this.mainColumnLabels.wiFi;

      case 'referrer_domains':
      case 'referrers':
      case 'subnet_small':
      case 'subnet_big':
        return this.mainColumnLabels.empty;
      
      case 'mobile_carriers':
      case 'oses':
      case 'os_versions':
      case 'browsers':
      case 'browser_versions':
      case 'device_models': 
      case 'device_vendors': 
      case 'screen_resolutions': 
      case 'countries': 
      case 'cities':
      case 'states':
      case 'regions':
      case 'isps':
      case 'device_types':
      case 'languages':
      default: 
        return this.mainColumnLabels.unknown;
    }
  }

  get rows() {
    return !this.pRows.length && this.subReport && this.parentRow && !this.loading
      ? []
      : this.pRows;
  }

  error: any = null;
  errorText: string = '';

  tree: {[type: string]: any} = {};
  resize: boolean = true;
  formatters: any = formatters;
  headerActions: any[] = [ ReportSorting ];
  refreshing: boolean = false;
  refreshed: boolean = false;
  freezed: boolean = false;

  get maxTreeLevel() {
    const keys = Object.keys(this.tree); 
    return keys.length;
  }

  get viewColumnsFilter(): string[] {
    const { dimensions } = this.$store.state.reportColumns
    // TODO: check this.isTreeView &&
    return this.isTreeView && this.treeLevels
      ? this.treeLevels
        .map((item: string) => dimensions[item]
          ? dimensions[item].mainColumn
          : null
        ).filter((item: string) => !!item)
      : []; 
  }

  get computedColumnsFilter() {
    return this.columnsFilter 
      ? this.columnsFilter 
      : this.viewColumnsFilter
  }


  get tableNoReportBlockVisible() {
    return !this.loading && this.treeLevel === 0;
  }

  @Watch('tableNoReportBlockVisible', {immediate: true})
  onTableNoReportBlockVisibleChanged(value: boolean) {
    this.$store.commit('tableNoReportBlockVisible', value);
  }

  get tableProgressBlockVisible() {
    return this.loading && !this.refreshing;
  }

  @Watch('tableProgressBlockVisible', {immediate: true})
  onTableProgressBlockVisibleChanged(value: boolean) {
    this.$store.commit('tableProgressBlockVisible', value);
  }

  //#GDB: generateIds
  get generateIds() {
    const { name } = this.$route;

    switch (name) {
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-clicks':
      case 'app.live-visits':
        return true;

      default:
        return false;
    }
  }

  //#GDB: selectableTypeOfReports
  get selectableTypeOfReports() {
    const { name } = this.$route;
    switch(name) {
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-clicks':
      case 'app.live-visits':
        return false;
      
      default:
        return true;
    }
  }

  get idPrefix() {
    return !this.previousFilter 
      ? null
      : this.previousFilter
        .map((value) => `${value.filterTables}-${value.filterValues}`);
  }

  get reportsWithArchiveButton() {
    return ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks'];
  }

  get reportsWithTotalCount() {
    return ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks'];
  }

  get isArchiveDisallowed() {
    return this.reportsWithArchiveButton.indexOf(this.$route.params.type) === -1;
  }

  get isHideFilters() {
    return this.isShowTreeViewControls || this.isNoSelect;
  }

  // do not refactor to computer property
  isNoSelect: boolean = false;

  get exportParamsGroupBy() {
    const levels = this.$store.getters.tableQueryForCurrentTab.treeLevels?.filter((e: string) => e);
  
    return this.isHideFilters
      ? [this.groupBy, ...(!!levels ? levels: [])]
      : this.groupBy;
  }

  @Watch('exportParamsGroupBy')
  onExportParamsGroupByChanged(value: any) {
    this.exportParams.groupBy = value;
  }

  @Watch('isHideFilters', {
    immediate: true
  })
  onIsHideFiltersChanged(value: boolean) {
    this.$store.commit('tableIsHideFilters', value);

    // if(value) {
    //   const levels = this.$store.state.tableTreeLevels && this.$store.state.tableTreeLevels.filter((e: string) => e);
    //   this.exportParams.groupBy = [this.groupBy, ...levels]
    // } else {
    //   this.exportParams.groupBy = this.groupBy;
    // }
  }

  get isTableTreeLevels() {
    return this.$store.getters.tableQueryForCurrentTab.treeLevels
      && this.$store.getters.tableQueryForCurrentTab.treeLevels.some((e: string) => e);
  }

  get isShowTreeViewControls() {
    return !!(this.isTreeView && this.isTableTreeLevels)
  }

  get treeLevels() {
    return this.$store.getters.tableQueryForCurrentTab.treeLevels?.filter((e: string) => e);
  }

  get isTreeView() {
    return this.$store.getters.tableQueryForCurrentTab.view === 'tree';
  }

  get utils(){
    return reportUtils(this);
  }

  get isDataRetentionTooOldDataRetrieved() {
    return this.error?.response?.status === 402 && this.error?.response?.data?.message === AppErrorEnum.dataRetentionTooOldDataRetrieved;
  }

  @Watch('isShowTreeViewControls')
  onIsTreeViewChanged(value: boolean, oldValue: boolean) {
    if(value !== oldValue) {
      this.bus.emit('tree-view-changed');
    }
  }

  ready() {
    this.resize = this.resizable;
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    if(!to.params.manual) {
      this.loading = true;
      this.freezed = true;
    }

    next();
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    next();
  }

  resetScrollPosition() {
    const { wrapper } = this.$refs as any
    wrapper?.scrollTo(0, 0)
  }

  @Watch('$route')
  onRouteChanged(value: any) {
    this.resetScrollPosition()
    this.$store.commit('tableMenuOverride', null);
  }

  rowSelected(data: any, treeLevel: number) {
    this.$store.commit('tableSelectedItems', data);

    const value = data.length == 1 ? data[0] : null;

    if (value && value.DT_RowUrl) {
      this.$store.commit('tablePreviewLink', value.DT_RowUrl);
    } else {
      this.$store.commit('tablePreviewLink', null);
    }

    if (value && value.DT_RowId) {
      this.$store.commit('tableNextReportTreeLevel', treeLevel);
      this.$store.commit('tableNextReportGroup', this.getGroupByMetric(value.grouping) || this.$route.params.type);
    } else {
      this.$store.commit('tableNextReportTreeLevel', 0);
      this.$store.commit('tableNextReportGroup', null);
    }
  }

  get columnsFilter() {
    return [this.tableDimensions.mainColumn, ...this.viewColumnsFilter]
  }

  addTree(item: any, group: string) {
    if(!this.tree[item.DT_RowId]) {
      this.$set(this.tree, item.DT_RowId, this.generateSubTable(item, group));
    } else {
      this.$delete(this.tree, item.DT_RowId);
    }
  }

  handleDrilldownForward(value: any, grouping: string) {
    this.bus.emit('freeze-table');

    this.$helpers.afterBrowserRedraw(() => { 
      let previousFilter = this.previousFilter
        ? this.previousFilter
        : [];

      this.$store.commit('clearTableTree');

      let tableNextReportGroup = this.getGroupByMetric(grouping);

      this.drilldownForward(previousFilter, {
        tableNextReport: value,
        tableNextReportGroup: tableNextReportGroup
      });

      this.bus.emit('reload-report');
    });
  }

  emptyRows: { [type: string]: any} = {};

  // RECURSION
  generateSubTable(item: any, group: string) {
    const DT_RowId = normalizeId(item.DT_RowId);

    this.$store.commit('tableTree', {
      index: this.treeLevel,
      value: {
        filterTables: this.getGroupByMetric(group) || this.type,
        filterValues: DT_RowId
      }
    });

    delete this.emptyRows[DT_RowId];

    return true
  }

  get enter() {
    return this.enterFuncBody;
  }

  // get getReportDebounced() {
  //   return debounce(this.getReport, 25);
  // }

  // get routeChangedDebounced() {
  //   return debounce(this.routeChanged, 25);
  // }


  enterFuncBody() {
    this.$store.commit('tableSelectedItems', null);
    // this.$store.commit('tableCustomGroups', null);

    if (!this.isDashbord) {
      this.getReport();
    }
  }

  params: any = {};


  @Watch('$route.name', { immediate: true })
  onRouteNameChanged() {
    this.setSorting();
  }

  pickReportFilters() {
    const { name } = this.$route;

    switch (name) {
      case 'app.conversions':
        return {
          ...this.getFilters(),
          formatResponse: 1,
          groupBy: 'conversions'
        }

      case 'app.postbacks':
        return {
          ...this.getFilters(),
          formatResponse: 1,
          groupBy: 'postbacks'
        }

      case 'app.errors':
        return {
          ...this.getFilters(),
          formatResponse: 1,
          groupBy: 'errors'
        }

      case 'app.live-clicks':
        return {
          ...this.getFilters(),
          formatResponse: 1,
          groupBy: `live-clicks`
        }

      case 'app.live-visits':
        return {
          ...this.getFilters(),
          formatResponse: 1,
          groupBy: `live-visits`
        }

      default:
        return this.getSimpleReportParams;
    }
  }

  get getSimpleReportParams() {
    const {view} = this.$store.getters.tableQueryForCurrentTab

    let params: any = {
      ...this.getFilters(),
      formatResponse: 1
    };

    const { metrics } = this.$store.state.reportColumns

    let dimensions: string[] = this.tableDimensions.additionalColumns
      ?.concat([this.tableDimensions.mainColumn])
      ?.concat(metrics);

    if(!dimensions) return;
    if(view) {
      const levels = this.$store.getters.tableQueryForCurrentTab.treeLevels?.filter((e: string) => e);
      if(view === 'table' && levels?.length) {
        params.groupBy = [params.groupBy, ...levels];

        const { dimensions: tableDimensions } = this.$store.state.reportColumns

        const viewColumns = levels.map((e: string) => tableDimensions[e].mainColumn);
        this.append_metrics = viewColumns.map((key: string) => ({
          text: this.reportMetricsName(key),
          value: key
        }));

        params.columns = _.uniq(params.columns.concat(viewColumns));
        dimensions = dimensions.concat(viewColumns)
      } else {
        this.append_metrics = [];
      }
    }

    if(!dimensions.includes(params.orderBy)) {
      params.orderBy = this.tableDimensions.mainColumn;
    }

    if(this.treeLevel > 0) {
      // use search only for 1 level
      delete params.searchBy;
      delete params.search;
      delete params.marks;
      delete params.marksFilterMode;
      delete params.tagsLogicalRelation;
      delete params.textLogicalRelation;
      delete params.tags;

      params.limit = 20;
      params.offset = 0;
    }

    return params;
  }

  get reportParams() {
    let params = _.cloneDeep(this.pickReportFilters());

    // array value with one item reads on server not as array, but as single variable
    // thats why we need to send array with to or more items
    if(params.columns && params.columns.length === 1) {
      params.columns.push(params.columns[0]);
    }

    let _query = this.reportQuery();
    let filter: Bemob.ReportQueryDrill[] = [];

    if( _query.filterTables && _query.filterValues) {
      filter.push({
        filterTables: _query.filterTables,
        filterValues: _query.filterValues,
        filterOptions: _query.filterOptions
      });
    }

    if(!this.$PL.compareReport){
      delete params.compareDate;
      delete params.compareFrom;
      delete params.compareTo;
      delete params.compareEnabled;
    }

    const {selectedWorkspaces, workspaces} = this.$store.state.user;
    if(selectedWorkspaces?.length===workspaces?.length){
      delete params.workspaceIds
    }else{
      params.workspaceIds = selectedWorkspaces;
    }
    
    if(_query.drill) {
      filter.push(..._query.drill);
    }

    if(this.previousFilter) {
      filter.push(...this.previousFilter);
    }

    if(filter) {
      params.filterTables = filter.map(item => item.filterTables);
      params.filterValues = filter.map(item => item.filterValues);
      params.filterOptions = filter.map(item => item.filterOptions);
    }

    if(this.$store.state.table.reportBoostEnabled) {
      params.columns = params.columns.filter((item)=>{
        params.orderBy = this.tableDimensions.mainColumn;
        return !this.$store.state.reportColumns.metrics.includes(item)
      })
    }

    return params;
  }

  exportParams: any = {};
  groupingValuesAcc: string[] = [];

  get groupingValues() {
    const { dimensions } = this.$store.state.reportColumns;
    return this.$store.getters.tableQueryForCurrentTab.treeLevels && this.isTableTreeLevels
      ? this.$store.getters.tableQueryForCurrentTab.treeLevels.map((item: string) => dimensions?.[item]?.mainColumn)
      : [];
  }

  @Watch('groupBy')
  onGroupByChanged() {
    this.groupingValuesAcc = [];
  }

  @Watch('groupingValues')
  onGroupingValuesChanged(value: string[]) {
    this.groupingValuesAcc = uniq(this.groupingValuesAcc.concat(value));
  }

  get getReport() {
    return debounce(this.getReportBody, 25);
  }

  async getReportBody() {
    this.error = null;
    this.loading = true;

    this.$store.commit('tableLoading', true);
    this.$store.commit('tableSelectedItems', null);
    this.bus.emit('clear-table-selection');

    const params = this.reportParams;

    if(this.treeLevel===0){
      this.$store.commit('tableExportParams', params);
    }

    this.isNoSelect = this.append_metrics.length && this.$store.getters.tableQueryForCurrentTab.view === 'table';
    let res;

    this.bus.emit('refresh-chart');
    try {
      res = await api.get(this.requestLink, {
        params: { 
          ...params,
          presetId: this.$store.state.report.activePreset
        },
        paramsSerializer: function (params: object) {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        }
      });

      if(this.treeLevel > 0) {
        const minTimeout = new Promise((resolve, reject) => {
          setTimeout(() => resolve(), 300);
        });

        await minTimeout;
      }
    } catch (error) {
      this.error = error;
      this.loading = false;
      this.refreshing = false;
    }

    if(!res) {
      return;
    }

    //this.bus.emit('chart-reload', requestParams);

    const payload = res.data.payload;

    // BMB-4758
    if(!this.isReport() && params.groupBy!==this.currentReportType){
      return
    }

    if(this.$route.name === 'app.report') {
      const verifiedParams = this.verifyQuery(params, this.treeLevel);
    } 
    //set totals for pagination

    if(this.subReport) {
      this.$emit('sub-report-total', payload.count);
    }else{
      this.$store.commit('tableTotal', payload.count);
    }

    if(this.subReport && !payload.count) {
      console.log('empty report issue');
    }

    this.refreshed = this.refreshing;

    //add rows
    this.pRows = payload.data.map((item: any) => {
      if(this.$route.name === 'app.postbacks'){
        item.DT_RowId = item['postbacks-clickid'] + '.' + moment.tz(item['postbacks-timestamp'], 'YYYY-MM-DD HH:mm:ss', this.$store.getters.reportParams.timezone).utc().unix()
      }

      if(item['DT_RowCampaignExternalName']){
        item['reports-' + params.groupBy] =
          `${item['reports-' + params.groupBy]} (${item['DT_RowCampaignExternalName']})`
      }

      if(!['app.postbacks'].includes(this.$route.name)) {
        item.profit_status = item['reports-profit'];
      }
      return item;
    });

    this.footer = payload.total;

    this.$store.commit('tableLoading', false);

    if(!this.refreshing && !this.subReport) {
      try {
        this.freezed = false;
      } catch(error) { }
    }
    
    this.loading = false;
    this.refreshing = false;

    this.$store.commit('loading', false);

    this.$filter.clear();

    this.bus.emit('report-update-complete');
  }

  @Watch('$store.state.user.selectedWorkspaces')
  selectedWorkspacesChanged(value,oldValue) {
    if(!isEqual(value,oldValue)){
      this.getReport();
    }
  }

  @Watch('$route',{immediate:true})
  route_changed(value: any, oldValue: any) {
    this.$store.commit('tableQuery', {
      grouping: this.currentReportType,
      name: 'groupBy',
      value: this.currentReportType,
      notSetToLocalStorage: !!this.$route.params.report,
    });
    if(!this.isReport()){
      this.$store.commit('tableLastGroupBy', this.currentReportType)
    }
    this.tree = {}
  }
  
}

export default Report;
